import React from "react";
import Title from "./Components/Title/Title"
import Table from "./Components/TableComponent/Table"


export default function RelatedServicesSettings() {
  return (
    <div className="p-4">
    <Title/>
      <Table />
     
    </div>
  );
}
